module.exports = __webpack_public_path__ + "img/福位系统2.5b339b7c.png";